/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';
import { Publication } from './publication';

export class Menu extends DaoModel {
  constructor(guid, title, point_of_sale, sale_zones, moments_of_consume, template,
    default_sale_formats, theme, priority, is_managed, external_link, external_link_text_alt1,
    external_link_text_alt2, external_link_text_alt3, publication, mainLanguage, secondLanguage,
    thirdLanguage, menu_configuration, menu_print_configuration, custom_logo, grid_configuration) {
    super(guid);
    this.title = title || `Menú ${new Date().toLocaleDateString()}`;
    this.point_of_sale = point_of_sale;
    this.sale_zones = sale_zones || [];
    this.moments_of_consume = moments_of_consume || [];
    this.template = template || null;
    this.default_sale_formats = default_sale_formats || [];
    this.theme = theme || null;
    this.priority = priority || 0;
    this.is_managed = is_managed || false;
    this.external_link = external_link || null;
    this.external_link_text_alt1 = external_link_text_alt1 || '';
    this.external_link_text_alt2 = external_link_text_alt2 || '';
    this.external_link_text_alt3 = external_link_text_alt3 || '';
    this.publication = publication || undefined;
    this.mainLanguage = mainLanguage || '';
    this.secondLanguage = secondLanguage || '';
    this.thirdLanguage = thirdLanguage || '';
    this.menu_configuration = menu_configuration || null;
    this.custom_logo = custom_logo || undefined;
    this.menu_print_configuration = menu_print_configuration || null;
    this.grid_configuration = grid_configuration || null;
  }

  static toInstance(props = {}) {
    const publication = props.publication ? Publication.toInstance(props.publication) : undefined;
    return new Menu(props.guid, props.title, props.point_of_sale, props.sale_zones,
      props.moments_of_consume, props.template,
      props.default_sale_formats, props.theme, props.priority,
      props.is_managed, props.external_link, props.external_link_text_alt1,
      props.external_link_text_alt2, props.external_link_text_alt3, publication, props.main_language,
      props.second_language, props.third_language, props.menu_configuration,
      props.menu_print_configuration, props.custom_logo, props.grid_configuration);
  }

  serialize() {
    return {
      ...super.serialize(),
      title: this.title,
      point_of_sale: this.point_of_sale,
      sale_zones: this.sale_zones,
      moments_of_consume: this.moments_of_consume,
      template: this.template,
      default_sale_formats: this.default_sale_formats,
      theme: this.theme,
      priority: this.priority,
      is_managed: this.is_managed,
      external_link: this.external_link,
      external_link_text_alt1: this.external_link_text_alt1,
      external_link_text_alt2: this.external_link_text_alt2,
      external_link_text_alt3: this.external_link_text_alt3,
      menu_configuration: this.menu_configuration,
      menu_print_configuration: this.menu_print_configuration,
      publication: this.publication ? this.publication.serialize() : null,
      main_language: this.mainLanguage || null,
      second_language: this.secondLanguage || null,
      third_language: this.thirdLanguage || null,
      custom_logo: this.custom_logo || null,
      grid_configuration: this.grid_configuration || null,
    };
  }

  getFormData() {
    const formData = new FormData();
    formData.append('title', this.title);
    formData.append('point_of_sale', this.point_of_sale);
    this.sale_zones.forEach((sale_zone) => {
      formData.append('sale_zones', sale_zone);
    });
    this.moments_of_consume.forEach((moment_of_consume) => {
      formData.append('moments_of_consume', moment_of_consume);
    });
    formData.append('template', this.template);
    this.default_sale_formats.forEach((default_sale_format) => {
      formData.append('default_sale_formats', default_sale_format);
    });
    formData.append('theme', this.theme ? this.theme : '');
    formData.append('priority', this.priority);
    formData.append('is_managed', this.is_managed);
    formData.append('external_link', this.external_link ? this.external_link : '');
    formData.append('external_link_text_alt1', this.external_link_text_alt1);
    formData.append('external_link_text_alt2', this.external_link_text_alt2);
    formData.append('external_link_text_alt3', this.external_link_text_alt3);
    formData.append('menu_configuration', this.menu_configuration ? this.menu_configuration : '');
    formData.append('menu_print_configuration', this.menu_print_configuration ? this.menu_print_configuration : '');
    formData.append('publication', this.publication ? this.publication : '');
    formData.append('main_language', this.mainLanguage);
    formData.append('second_language', this.secondLanguage);
    formData.append('third_language', this.thirdLanguage);

    if (this.custom_logo instanceof File) {
      if (this.custom_logo.size !== 0) {
        formData.append('custom_logo', this.custom_logo, this.custom_logo.name);
      }
    } else if (!this.custom_logo) {
      formData.append('custom_logo', '');
    }

    return formData;
  }
}
